import { Component, OnInit } from "@angular/core";

@Component({
  selector: "fgb-ecash-history",
  templateUrl: "./ecash-history.component.html",
  styleUrls: ["./ecash-history.component.scss"],
})
export class EcashHistoryPageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
